var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-certificate"},[_c('img',{staticClass:"background-certificate",attrs:{"src":_vm.BlankFileUrl,"alt":"Background Image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }